module.exports = __webpack_public_path__ + "static/image/sustainability/m/ethical.ver2_0_2.jpg?c23d0a0e";